import { OptionHolder } from "../../input/select/options";
import { Validation } from "../Restrictions";

export interface Dependency {
    type: DependencyType;
    value?: string;
    options?: OptionHolder;
    validations?: Validation[];
    conditions: Array<DependencyCondition | BooleanDependencyCondition>;
}

export interface TableColumnDepedency extends Dependency {
    targetColumn: string;
}
export function isTableColumnDepedency(dependency: Dependency): dependency is TableColumnDepedency {
    return (dependency as TableColumnDepedency).targetColumn !== undefined;
}
export interface ExpressionDependency extends Dependency {
    expression: string;
}

export function isExpressionDependency(arg: any): arg is ExpressionDependency {
    return arg.expression !== undefined && arg.type !== undefined;
}

export interface Condition { }
export interface DependencyCondition extends Condition {
    property: string;
    status: RemoteStatusType;
    compareOperator: RemoteStatusCompareType;
    values: any[];
}

export function isDependencyCondition(arg: any): arg is DependencyCondition {
    return arg.property !== undefined && arg.status !== undefined;
}

export interface BooleanDependencyCondition extends Condition {
    booleanOperator: "and" | "or";
    conditions: Condition[];
}
export interface ComparisonDependencyCondition extends Condition {
    comparisonOperator: "equal" | "different";
    conditions: DependencyCondition[];
}

export function isBooleanDependencyCondition(arg: any): arg is BooleanDependencyCondition {
    return arg.booleanOperator !== undefined && arg.conditions !== undefined;
}
export function isComparisonDependencyCondition(arg: any): arg is ComparisonDependencyCondition {
    return arg.comparisonOperator !== undefined && arg.conditions !== undefined;
}

export enum DependencyType {
    enabled = "enabled",
    disabled = "disabled",
    required = "required",
    optional = "optional",
    visible = "visible",
    hidden = "hidden",
    value = "value",
    disabledOptions = "disabledOptions",
    queryParameters = "queryParameters",
    validation = "validation",
}

export enum RemoteStatusType {
    empty = "empty",
    filled = "filled",
    checked = "checked",
    unchecked = "unchecked",
    expanded = "expanded",
    collapsed = "collapsed",
    value = "value",
    notvalue = "notvalue",
    any = "any",
}

export enum RemoteStatusCompareType {
    "equal",
    "different",
    "greater",
    "gte",
    "less",
    "lte",
    "begins",
    "contains",
    "ends",
}
